<template>
  <b-modal
    ref="clone-item-modal"
    id="clone-item-modal"
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
    :title="title"
    size="sm"
  >
    <div v-if="stage == 'dialog'">
      <b-row>
        <b-col md="12">
          <p
            v-html="
              `${cartLength} item(s) are already present in the cart.<br/><br/>Press 'Continue' to add invoice items in current cart or press 'Remove and add' to discard already present items.`
            "
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6" class="pr-1"
          ><b-button variant="outline-primary" block @click="remove"
            >Remove & add</b-button
          ></b-col
        >
        <b-col md="6" class="pl-1" @click="add"
          ><b-button variant="primary" block>Continue</b-button></b-col
        >
      </b-row>
    </div>
    <div v-if="stage == 'remove'">
      <b-row>
        <b-col md="12">
          <p
            v-html="`${cartLength} item(s) are being removed from the cart.`"
          />
        </b-col>
        <b-col md="12">
          <b-progress animated :max="100" :value="100" />
        </b-col>
      </b-row>
    </div>
    <div v-if="stage == 'add'">
      <b-row>
        <b-col md="12">
          <p v-html="`${addData.on}/${addData.total} products added`" />
        </b-col>
        <b-col md="12">
          <b-progress
            animated
            :max="addData.total"
            :value="addData.on"
            show-progress
          />
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>
<script>
import { mapState } from "vuex";
import * as msg from "../message";
export default {
  name: "clone-items-to-cart",
  props: ["invoiceData"],
  data() {
    return {
      stage: "dialog",
      title: "Warning",
      addData: {
        total: 0,
        on: 0,
      },
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
    isCartEmpty() {
      let temp = true;
      if (this.state.billing.billing.cart.hasOwnProperty("data")) {
        if (this.state.billing.billing.cart.data.length) temp = false;
      }
      return temp;
    },
    cartLength() {
      return this.state.billing.billing.cart.hasOwnProperty("data")
        ? this.state.billing.billing.cart.data.length
        : 0;
    },
  },
  methods: {
    initialize() {
      if (this.isCartEmpty) this.add();
      else {
        this.title = "Warning";
        this.stage = "dialog";
      }
      this.$refs["clone-item-modal"].show();
    },
    remove() {
      this.title = "Emptying Cart";
      this.stage = "remove";
      let data = Object.assign(
        {
          barcode: "",
          url: "remove-product-from-cart",
          product_id: "",
          cart_id: "",
          all: "1",
          cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
            "gstin"
          )
            ? this.state.billing.billing.customer.data.gstin
            : "",
        },
        this.essentialsData,
        this.customerData
      );
      this.$store
        .dispatch("billing/cancelBill", data)
        .then(() => this.add())
        .catch(() => {
          this.closeModal();
          this.$store.commit("notifications/showAlert", {
            message: msg.INTERNAL_SERVER_ERROR,
            type: "danger",
          });
          this.$showAlert = true;
        });
    },
    add(src = "") {
      if (src == "next") this.addData.on += 1;
      else {
        this.title = "Adding products";
        this.stage = "add";
        this.addData = { total: this.invoiceData.length, on: 0 };
      }
      this.addToCart(this.invoiceData[this.addData.on]);
    },
    addToCart(pdata) {
      if (this.checkEmpty(pdata)) {
        this.$store.dispatch("billing/cartDetails").then(() => {
          this.closeModal();
          //   this.$store.commit("notifications/showAlert", {
          //     message: "Invoice cloned to cart",
          //     type: "success",
          //   });
          //   this.$showAlert = true;
          this.$router.push("/");
          return;
        });
        return;
      }

      let data = Object.assign(
        {
          barcode: pdata.product_data.barcode,
          scan: "TRUE",
          url: "product-details",
          qty: pdata.qty,
          change_mrp: "",
          batch_id: "0",
          serial_id: "0",
          cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
            "gstin"
          )
            ? this.state.billing.billing.customer.data.gstin
            : "",
        },
        this.essentialsData,
        this.customerData
      );
      if (!this.checkEmpty(pdata.product_data.batch_id)) {
        data.batch_id = pdata.product_data.batch_id;
      } else if (!this.checkEmpty(pdata.product_data.serial_id)) {
        data.serial_id = pdata.product_data.serial_id;
      } else if (pdata.product_data.multiple_mrp.length > 1) {
        data.change_mrp = pdata.amount;
      }
      this.$store
        .dispatch("billing/addToCart", data)
        .then((res) => {
          if (res.data.status != "fail") this.add("next");
        })
        .catch(() => {
          this.closeModal();
          this.$store.commit("notifications/showAlert", {
            message: msg.INTERNAL_SERVER_ERROR,
            type: "danger",
          });
          this.$showAlert = true;
        });
    },
    closeModal() {
      this.$refs["clone-item-modal"].hide();
      this.stage = "dialog";
      this.title = "Warning";
      this.addData = {
        total: 0,
        on: 0,
      };
    },
  },
};
</script>

<style></style>
